import { ValidationModel, ValidationType } from "@/services/validation/types";

export const propertiesValidators = {
    url: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.URL }
        ]
    } as ValidationModel,
    width: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    height: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    grabWidth: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    grabHeight: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    x: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 0 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    y: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 0 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    zoom: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    reloadTime: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 0 }
        ]
    } as ValidationModel
};
